function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 .521)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M19.866 16.935l-9-15.945a.989.989 0 00-1.732 0l-9 15.944a1.041 1.041 0 000 1.023 1 1 0 00.866.512h18a1 1 0 00.866-.511 1.041 1.041 0 000-1.023zM1 17.446L10 1.5l9 15.944z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M10 13.19a.5.5 0 01-.5-.5v-7a.5.5 0 011 0v7a.5.5 0 01-.5.5z"
}),
/*#__PURE__*/
React.createElement("circle", {
  cx: 0.75,
  cy: 0.75,
  r: 0.75,
  transform: "translate(9.25 14.652)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20.001,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgWarning, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Warning.ef9e68d4.svg";
export { ForwardRef as ReactComponent };